import {
  __async
} from "./chunk--chunk-RQ7252KT.js";

// src/js/components/ProductForm.js
var ProductForm = class {
  constructor(el, sel) {
    this.el = el;
    this.productID = el.getAttribute(sel);
    this.input = el.querySelector('input[name="id"]');
    const quantitySelector = this.el.querySelector("[data-quantity]");
    if (quantitySelector) {
      this.quantity = quantitySelector.querySelector("input");
      this.plus = quantitySelector.querySelector("[data-plus]");
      this.minus = quantitySelector.querySelector("[data-minus]");
    }
    const subscriptionsWidget = this.el.querySelector(
      "[data-subscriptions-widget]"
    );
    if (subscriptionsWidget) {
      this.subscriptionsWidget = subscriptionsWidget;
    }
    const variantPicker = this.el.querySelector("[data-variant-picker]");
    if (variantPicker) {
      this.variantPicker = variantPicker;
      this.variantData = JSON.parse(
        variantPicker.querySelector('script[type="application/json"]').textContent
      ).variantJson;
      this.metafieldData = JSON.parse(
        variantPicker.querySelector('script[type="application/json"]').textContent
      ).metafieldJson;
      if (variantPicker.getAttribute("data-variant-picker") === "main product form") {
        this.isMainProductForm = true;
      }
    }
    if (this.variantPicker) {
      document.addEventListener("variant change listener attached", () => {
        this.getCurrentVariant();
      });
    }
  }
  init() {
    this.initSubmitListener();
    if (this.quantity)
      this.initQuantitySelector();
    if (this.variantPicker) {
      this.getCurrentVariant();
      this.initVariantPicker();
    }
  }
  initSubmitListener() {
    this.el.addEventListener("submit", (e) => __async(this, null, function* () {
      e.preventDefault();
      try {
        const formData = new FormData(this.el);
        const body = new URLSearchParams(formData);
        const res = yield fetch("/cart/add.js", {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          method: "POST",
          body
        });
        if (res.status === 200) {
          const rec = this.el.closest("[data-cart-rec]");
          if (rec) {
            const checkbox = rec.querySelector('input[type="checkbox"]');
            if (checkbox)
              checkbox.checked = false;
          }
          const cartRes = yield fetch("/?sections=ajaxcart");
          const cartJson = yield cartRes.json();
          const div = document.createElement("div");
          div.innerHTML = cartJson.ajaxcart;
          const cartContent = div.querySelector("[data-ajax-cart-content]");
          const cartEl = document.querySelector("[data-ajax-cart] [data-ajax-cart-content]").parentNode;
          cartEl.innerHTML = "";
          cartEl.appendChild(cartContent);
          const subtotalValue = div.querySelector("[data-subtotal-value]").value;
          const subtotalEls = document.querySelectorAll("[data-subtotal]");
          subtotalEls.forEach((subtotalEl) => {
            subtotalEl.innerHTML = subtotalValue;
          });
          document.dispatchEvent(new CustomEvent("ajaxcart refresh"));
        }
      } catch (err) {
        console.error(err);
      }
    }));
  }
  initQuantitySelector() {
    this.plus.addEventListener("click", () => {
      this.quantity.value++;
    });
    this.minus.addEventListener("click", () => {
      if (this.quantity.value <= 1) {
        return;
      }
      this.quantity.value--;
    });
  }
  initVariantPicker() {
    if (this.isMainProductForm) {
      const currentVariant = this.getCurrentVariant();
      if (!window.location.href.includes("?variant=")) {
        window.history.replaceState({}, "", `?variant=${currentVariant.id}`);
      }
    }
    const oneTime = document.querySelector('[data-subscription-input][value="one-time"]');
    this.variantPicker.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = input.parentElement.querySelector("label");
      label.addEventListener("click", () => {
        input.click();
      });
      input.addEventListener("change", () => {
        oneTime.click();
        const currentVariant = this.getCurrentVariant();
        if (this.isMainProductForm) {
          window.history.replaceState(
            {},
            "",
            `?variant=${currentVariant.id}`
          );
        }
      });
    });
  }
  updatePriceEls(currentVariant) {
    const prices = document.querySelectorAll("[data-price]");
    const subscriptionsPrices = document.querySelectorAll("[data-subscription-price]");
    const price = document.querySelector("[data-price]:not([data-price='sticky-cta'])");
    const subscriptionApp = document.querySelector(".shopify_subscriptions_app_block");
    this.subscriptionsWidget.addEventListener("change", (e) => {
      let sellingPlanPrice = currentVariant.selling_plan_allocations[0].price;
      const sellingPlan = document.querySelector('input[type="radio"][value="subscription"]:checked');
      if (sellingPlan) {
        price.innerHTML = "";
        const sellingPriceSpan = document.createElement("span");
        sellingPriceSpan.setAttribute(
          "class",
          "selling-price"
        );
        sellingPriceSpan.innerHTML = (sellingPlanPrice / 100).toLocaleString(
          "en-US",
          {
            style: "currency",
            currency: "USD"
          }
        );
        const crossOutPrice = document.createElement("span");
        crossOutPrice.setAttribute(
          "style",
          "text-decoration:line-through;color:#878C8D;"
        );
        crossOutPrice.innerHTML = (currentVariant.price / 100).toLocaleString("en-US", {
          style: "currency",
          currency: "USD"
        });
        const discount = 100 - Math.round(sellingPlanPrice * 100 / currentVariant.price);
        const saveSpan = document.createElement("span");
        saveSpan.innerHTML = `SAVE ${discount}%`;
        price.appendChild(crossOutPrice);
        price.appendChild(sellingPriceSpan);
        price.appendChild(saveSpan);
        return;
      } else {
        if (prices.length > 0) {
          prices.forEach((price2) => {
            const context = price2.getAttribute("data-price");
            price2.innerHTML = "";
            if (currentVariant.compare_at_price > currentVariant.price && context !== "sticky-cta" && context !== "subscription-widget") {
              const crossOutPrice = document.createElement("span");
              crossOutPrice.setAttribute(
                "style",
                "text-decoration:line-through;color:#878C8D;"
              );
              crossOutPrice.innerHTML = (currentVariant.compare_at_price / 100).toLocaleString("en-US", {
                style: "currency",
                currency: "USD"
              });
              price2.appendChild(crossOutPrice);
            }
            const priceSpan = document.createElement("span");
            priceSpan.innerHTML = (currentVariant.price / 100).toLocaleString(
              "en-US",
              {
                style: "currency",
                currency: "USD"
              }
            );
            price2.appendChild(priceSpan);
            if (currentVariant.compare_at_price > currentVariant.price && context !== "sticky-cta" && context !== "subscription-widget") {
              const discount = 100 - Math.round(currentVariant.price * 100 / currentVariant.compare_at_price);
              const saveSpan = document.createElement("span");
              saveSpan.innerHTML = `SAVE ${discount}%`;
              price2.appendChild(saveSpan);
            }
          });
        }
      }
    });
    if (subscriptionsPrices.length > 0 && currentVariant.selling_plan_allocations.length > 0) {
      subscriptionsPrices.forEach((price2) => {
        price2.innerHTML = "";
        price2.innerHTML = (currentVariant.selling_plan_allocations[0].price / 100).toLocaleString("en-US", {
          style: "currency",
          currency: "USD"
        });
      });
    }
    if (prices.length > 0) {
      prices.forEach((price2) => {
        const context = price2.getAttribute("data-price");
        price2.innerHTML = "";
        if (currentVariant.compare_at_price > currentVariant.price && context !== "sticky-cta" && context !== "subscription-widget") {
          const crossOutPrice = document.createElement("span");
          crossOutPrice.setAttribute(
            "style",
            "text-decoration:line-through;color:#878C8D;"
          );
          crossOutPrice.innerHTML = (currentVariant.compare_at_price / 100).toLocaleString("en-US", {
            style: "currency",
            currency: "USD"
          });
          price2.appendChild(crossOutPrice);
        }
        const priceSpan = document.createElement("span");
        priceSpan.innerHTML = (currentVariant.price / 100).toLocaleString(
          "en-US",
          {
            style: "currency",
            currency: "USD"
          }
        );
        price2.appendChild(priceSpan);
        if (currentVariant.compare_at_price > currentVariant.price && context !== "sticky-cta" && context !== "subscription-widget") {
          const discount = 100 - Math.round(currentVariant.price * 100 / currentVariant.compare_at_price);
          const saveSpan = document.createElement("span");
          saveSpan.innerHTML = `SAVE ${discount}%`;
          price2.appendChild(saveSpan);
        }
      });
    }
  }
  toggleSubscriptionWidget(currentVariant) {
    const subscriptionWidget = document.querySelector("[data-subscriptions-widget]");
    const subscriptionContainer = document.querySelector("[data-subscription-container]");
    console.log(currentVariant);
    if (currentVariant.selling_plan_allocations.length > 0) {
      subscriptionWidget.classList.remove("hidden");
    } else {
      subscriptionWidget.classList.add("hidden");
    }
  }
  getCurrentVariant() {
    const currentVariantValue = this.variantPicker.querySelector(
      'input[type="radio"]:checked'
    );
    const currentVariant = this.variantData.find(
      (variant) => variant.options.includes(currentVariantValue.value)
    );
    const preorderData = this.metafieldData[currentVariant.id.toString()];
    const isPreorder = preorderData[0];
    const preorderVerbiage = preorderData[1];
    const ctaLabel = this.el.querySelector("[data-label]");
    if (ctaLabel) {
      ctaLabel.innerHTML = isPreorder ? ctaLabel.getAttribute("data-preorder-label") : ctaLabel.getAttribute("data-available-label");
      const verbiageEl = this.el.querySelector("[data-preorder-verbiage]");
      if (isPreorder) {
        ctaLabel.innerHTML = ctaLabel.getAttribute("data-preorder-label");
        verbiageEl.innerHTML = preorderVerbiage;
        verbiageEl.style.display = "block";
      } else {
        ctaLabel.innerHTML = ctaLabel.getAttribute("data-available-label");
        verbiageEl.style.display = "none";
      }
      document.dispatchEvent(new CustomEvent("atc label update", {
        detail: {
          label: ctaLabel.innerHTML
        }
      }));
    }
    this.input.value = currentVariant.id;
    if (this.isMainProductForm) {
      this.updatePriceEls(currentVariant);
      this.toggleSubscriptionWidget(currentVariant);
      document.dispatchEvent(new CustomEvent("variant update", {
        detail: {
          value: currentVariantValue.value.split("|")[0]
        }
      }));
    }
    return currentVariant;
  }
};
var ProductForm_default = ProductForm;

export {
  ProductForm_default
};
